import {AthumiService} from "@/api/enterprise-gateway-api.proxy.ts";

const ELYS_TERMS_AND_CONDITIONS_LINK: string = import.meta.env.VITE_ELYS_TERMS_AND_CONDITIONS;
const KLIP_TERMS_AND_CONDITIONS_LINK: string = import.meta.env.VITE_KLIP_TERMS_AND_CONDITIONS;
const VIP_TERMS_AND_CONDITIONS_LINK: string = import.meta.env.VITE_VIP_TERMS_AND_CONDITIONS;

export const getServiceTermsLink = (service: AthumiService): string | undefined => {
    switch (service) {
        case AthumiService.ELys:
            return ELYS_TERMS_AND_CONDITIONS_LINK;
        case AthumiService.Klip:
            return KLIP_TERMS_AND_CONDITIONS_LINK;
        case AthumiService.Vip:
            return VIP_TERMS_AND_CONDITIONS_LINK;
        default:
            return undefined;
    }
};